<template>
  <div class="layout-vertical d-flex w-100 flex-column position-relative">
    <headerCom v-if="state.headerVisible" :is-login="state.userInfoGlobal.isLogin" @loginClick="state.showLogin = true" @logoutClick="logout" />
    <router-view @loginClick="state.showLogin = true" class="page-content"/>
    <footerCom/>
    <!-- v-show="route.name !== 'AiFlashDrawing'" -->
    <!--登录-->
    <el-dialog class="login-dialog dialogR" v-model="state.showLogin" :modal="false">
      <iframe class="login-iframe" :src="state.loginUrl" sandbox="allow-scripts allow-top-navigation allow-same-origin allow-popups" />
    </el-dialog>
  </div>
</template>

<script setup>
import headerCom from '@/components/HeaderCom'
import footerCom from '@/components/FooterCom'
import * as Base64 from 'js-base64'
import { useRoute } from 'vue-router'
import { onMounted, ref, inject, reactive } from 'vue'
import userInfoService from '@/utils/userinfoservice'
import { saveloginrecord, getVisit } from '../utils/api'
const route = useRoute()
// 访问量统计
const imprint = async (e) => {
  let thcode = route.query.thcode || e;
  let param = {
    thcode: thcode,
    source: 3
  };
  try {
    const res = await getVisit(param);
    console.log(res);
  } catch (error) {
    console.error('Error fetching visit data:', error);
  }
};

const handleEvent = (msg) => {
  // 判断是否是字符串
  if (msg && msg.data === 'login') {
    state.userInfoGlobal = userInfoService.getUserData(state.userInfoGlobal)
    state.showLogin = false
    let param = {
      source: 3
    }
    saveloginrecord(param).then(res => {
      console.log(res)
    })
    imprint('GW')
  }
}

/**
 * 连接初始化(iframe)
 */
onMounted(() => {
  window.addEventListener('message', handleEvent)
  // 判断手机还是电脑
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  if (!flag) {
    //电脑
    state.pcDevice = true
    state.appDevice = false
  } else {
    //手机
    state.pcDevice = false
    state.appDevice = true
  }
})

// const router = useRouter()
const userInfoGlobal = ref(inject('$userInfoGlobal'))
const state = reactive({
  userInfoGlobal,
  pcDevice: true,
  appDevice: false,
  isLogin: false,
  headerVisible: true, // 头组件
  showLogin: false,
  loginUrl: window.SITE_CONFIG.websiteBaseUrl + '/#/UserLogin?page=' + Base64.encode(window.location.href) + '&source=3'
})
/**
 * 退出登录
 */
const logout = () => {
  userInfoService.logout().then(() => {
    state.userInfoGlobal = userInfoService.getUserData(state.userInfoGlobal)
  })
}
</script>
<style lang="scss" scoped>
.page-content{
  padding-top: 50px;
}
  .layout-vertical {
    background: #181a1e; /*主题背景色*/
    overflow: hidden;
  }
  :deep(.login-dialog) {
      padding: 0 !important;
      background-color: #ffffff00;
    }
  ::v-deep(.dialogR) {
    width: max-content;
    display: flex;
    justify-content: center;
    margin-top: 80px;

    .el-dialog__header {
      padding: 0 !important;
      margin: 0 !important;
    }

    .el-dialog__body {
      padding: 0;
      border-radius: 10px;
    }

  }

  @media (min-width: 740px) {
    .login-iframe {
      width: 700PX !important;
      height: 560PX !important;
      border-radius: 10px;
    }
  }

  @media (max-width: 740px) {
    .login-iframe {
      width: 370PX !important;
      height: 500PX !important;
      border-radius: 10px;
    }
  }
</style>
